import { $, _, Backbone, Radio, moment, Foundation } from "../../../vendor";
import { Biscuit } from "../../utils";
import { parseUrlIntoObject, getEnvPrefix } from "../../utils/Uri";
import InboomaBaseView from "../InboomaBaseView";
import InboomaSelectBox from "../../utils/InboomaSelectBox";

import SidebarFilterBehavior from "../../behaviors/Behavior.SidebarFilter";

import OrdersSidebarTpl from "../../templates/orders/OrdersSidebarTpl.html";
import { appRollingLoaderAnim } from "../AppAnnouncements";
import { getApiHost } from "../../Sync";
import * as FileSaver from "../../../vendor/FileSaver";

export default InboomaBaseView.extend({
  template: OrdersSidebarTpl,
  el: "#inb-c-sidebar",

  _filterSettings: [],

  templateContext() {
    // Shall we reduce location items for this user?
    let managerHasLocations = Biscuit.get("user.user_locations");

    if (managerHasLocations !== "") {
      managerHasLocations = managerHasLocations.split(",");
    }

    let locations = Radio.channel("locationsWithTrashed").request("get:data").getAllLocations();

    locations = _.sortBy(locations, (location) => location.get("name"));

    const host = getEnvPrefix();
    return {
      _,
      moment,
      Biscuit,
      schedule: `https://${host}cal.inbooma.net?hash=${Biscuit.get("client.hash")}`,
      heart_schedule: `https://${host}cal.inbooma.net?hash=${Biscuit.get("client.hash")}&network=herzroute`,
      // /Duplicate
      managerHasLocations,
      params: parseUrlIntoObject(),
      users: Radio.channel("users").request("get:data"),
      locations,
    };
  },

  ui: {
    dropdown: ".inb-dropdown",
    selectCustomer: "#inb-c-left-bar-flist--customer-select",
    dropdown: "#choose-new-order",
    addOrderNewCustomer: "#add-order-new-customer",
    backButton: "#back-button-container",
  },

  events: {
    "click .inb-toggle-sidebar-dd": "_initDropdown",
    "click #order-sidebar-tags-update-btn": "_updateTagList",
    "click .inb-fake-tag": "_triggerTag",
    "click #export-xls": "_export",
  },

  behaviors: [
    {
      behaviorClass: SidebarFilterBehavior,
      unselectAllFilter: (view) => {
        if (Biscuit.get("user.role") !== "user") {
          view._userFilterSelectBox._reset();
        }
      },
      filterMap: {
        // Map for all non-select2 filter components
        status2: (view, filterVal) => {
          view.collection.filterByStatus(filterVal);
        },
        tag: (view, filterVal) => {
          view.collection.filterByTag(filterVal);
        },
      },
    },
  ],

  resetSidebarFilter() {
    this.getUI("flistDates").find("li").removeClass("active").find("span").html("");
  },

  _initDropdown(ev) {
    ev.preventDefault();

    if (typeof this._dropdown === "undefined") {
      this._dropdown = new Foundation.Dropdown($("#inb-c-sidebar .inb-dropdown"));
    }

    this._dropdown.open();

    return false;
  },

  /**
   * Restore all given/previous filters in view and collection
   */
  _restoreFilterSettings() {
    const that = this;

    _.each(this.collection.getFiltersWithValue(), (val, type) => {
      switch (type) {
        case "status":
          that.$el.find(`#inb-c-left-bar-flist--status li[data-inb-val="${val}"]`).trigger("click");
          break;

        case "user_id":
          that._preFilterUser(val);
          break;
      }
    });
  },

  initialize() {
    this.render();
    this._restoreFilterSettings();
  },

  /**
   * Async search for the to-be-filtered user, then trigger the
   * collection filter and auto-set the user in the SelectBox
   *
   * @param {String} user_id
   */
  _preFilterUser(user_id) {
    const that = this,
      users = Radio.channel("users").request("get:data");

    users.fetchById(user_id, (user) => {
      if (!user) return;
      that._userFilterSelectBox.setValue(user.get("first_name") + " " + user.get("last_name"));
      that._userFilterSelectBox.getOption("onSelectItem")(user);
    });
  },

  _updateTagList() {
    const that = this;

    // fetch order tags
    const RequestHelper = Backbone.Model.extend({ urlRoot: "/tags?namespace=Orders" });

    new RequestHelper(null).fetch({
      success(model, response) {
        console.log("response: ", response);

        if (response.success) {
          // put tags into list of available tags, clear tags
          console.log("update tags");
          var fakeTagBox,
            tagBox = document.getElementById("inb-c-left-bar-flist--tag");
          for (var i = 0; i < tagBox.childNodes.length; i++) {
            if (tagBox.childNodes[i].tagName == "LI") {
              tagBox.removeChild(tagBox.childNodes[i]);
              i--;
            } else if (tagBox.childNodes[i].tagName == "UL") {
              fakeTagBox = tagBox.childNodes[i];
              fakeTagBox.innerHTML = "";
            }
          }
          // set hidden tags and fake tags
          for (var i = 0; i < response.data.length; i++) {
            // hidden tags
            var tag = document.createElement("li");
            var content = document.createElement("a");
            content.innerHTML = response.data[i].label;
            content.setAttribute("href", "#");
            content.setAttribute("class", "order-sidebar-tag-link");
            tag.setAttribute("class", "hide");
            tag.setAttribute("data-counter", response.data[i].counter);
            tag.setAttribute("data-inb-val", response.data[i].label);
            tag.setAttribute("title", that.t("filter_tag_${a}", { a: response.data[i].label }));
            tag.appendChild(content);
            tagBox.appendChild(tag);

            // fake tags
            if (fakeTagBox === undefined) continue;
            var fakeTag = document.createElement("li");
            var fakeContent = document.createElement("a");
            fakeContent.innerHTML = response.data[i].label;
            fakeContent.setAttribute("href", "#");
            fakeTag.setAttribute("class", "inb-fake-tag");
            fakeTag.setAttribute("data-counter", response.data[i].counter);
            fakeTag.setAttribute("data-inb-val", response.data[i].label);
            fakeTag.setAttribute("title", that.t("filter_tag_${a}", { a: response.data[i].label }));
            fakeTag.appendChild(fakeContent);
            fakeTagBox.appendChild(fakeTag);
          }
        } else {
          console.log("ERROR: failed to get tags response");
        }
      },
      error(model, response) {
        console.log("Error, could not request tags.");
      },
    });
  },

  _triggerTag(ev) {
    // get corresponding tag and trigger it

    var fakeTagBox = ev.target.parentNode.parentNode;
    var tagIndex,
      tagBox = fakeTagBox.parentNode;
    for (var i = 0; i < fakeTagBox.childNodes.length; i++) {
      if (fakeTagBox.childNodes[i].childNodes[0] == ev.target) {
        tagIndex = i;
        break;
      }
    }
    if (tagIndex === undefined) return;

    for (var j = -1, i = 0; i < tagBox.childNodes.length; i++) {
      if (tagBox.childNodes[i].tagName == "LI") {
        j++;
      }
      if (j == tagIndex) {
        $(tagBox.childNodes[i]).trigger("click");
        return;
      }
    }
  },

  _export() {
    const that = this;
    let params = "",
      count = 0,
      begin = null,
      end = null;
    _.each(this.collection.getFiltersWithValue(), (val, type) => {
      if (count > 0) {
        params += "&" + type + "=" + val;
      } else {
        params += "?" + type + "=" + val;
      }
      if (type.substr(0, 5) == "begin") {
        begin = val;
      }
      if (type.substr(0, 3) == "end") {
        end = val;
      }
    });
    let timestring = "";
    if (begin !== null) {
      timestring = "von " + begin + " ";
    }
    if (begin !== null) {
      timestring += "bis " + end + " ";
    }
    const xmlHttp = new XMLHttpRequest();

    xmlHttp.open("GET", getApiHost() + "/orders/export" + params, true);

    //  xmlHttp.setRequestHeader('Accept', 'application/json')
    xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
    xmlHttp.responseType = "blob";

    xmlHttp.onload = function () {
      const blob = new Blob([xmlHttp.response], { type: "application/xls" });
      FileSaver.saveAs(blob, that.t("orders") + " " + that.get_today() + ".xlsx");
    };

    xmlHttp.send(null);
  },
  get_today() {
    let today = new Date();

    let day = today.getDate(); // Tag

    // Monatsangabe startet bei 0!
    let month = today.getMonth() + 1; // Monat

    let year = today.getFullYear(); // Jahr
    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    today = day + "." + month + "." + year;

    return today;
  },

  onRender() {
    if (Biscuit.get("user.role") !== "user") {
      const that = this;
      let userQueryState = {
        value: "",
        timeStamp: moment().format("x"),
      };

      // USER FILTER: Filter orders by customer
      const users = Radio.channel("users").request("get:data");

      this._userFilterSelectBox = new InboomaSelectBox({
        el: this.getUI("selectCustomer"),
        collection: users,
        placeholder: this.t("select_${a}", { a: this.t("customer") }, "capital"),
        sortBy: "first_name",
        openListOnClose: false,
        listItemContent: (model) => {
          if (
            (typeof model.get("role") !== "undefined" && model.get("role") === "admin") ||
            model.get("active") === false
          ) {
            return "";
          }

          return model.get("first_name") + " " + model.get("last_name");
        },
        onSearch: (query) => {
          users._filterParams = { q: query };
          users._skipPagination = true;

          if (query.length > 2) {
            // make only requests with more than 2 characters
            setTimeout(function () {
              var diff = Number(moment().format("x")) - userQueryState.timeStamp;
              if (diff > 700 && userQueryState.value == query) {
                // no changes after the last 700 ms -> user finished input -> start request
                users.fetchNextPage(_.noop); // -> this avoids additional requests during typing
              }
            }, 800);
          }
          // update query state
          userQueryState.timeStamp = Number(moment().format("x"));
          userQueryState.value = query;
        },
        onSelectItem: (model) => {
          that.collection.filterByUser(model.get("id"));
        },
        onReset: () => {
          that.collection.removeFilter("user_id");
        },
      });

      const params = parseUrlIntoObject();

      if (typeof params.user_id !== "undefined" && typeof params.skipFilter === "undefined") {
        this._preFilterUser(params.user_id);
      }

      // get tags from api and fill tag box
      this._updateTagList();
    }
  },
});
